import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "../Popup/Popup";

interface Props {
	onDismiss: () => void;
	onAccept: () => void;
}

interface State {
}

class GreenListRemovePopUp extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	render() {
		return <Popup
			id={ "GreenListRemove" } title={ Strings.information } showIcon={ false }
			onDismiss={ this.props.onDismiss } modalBodyContainer="">
			<div className="modal-body">
				<p>{ Strings.disable_green_list }</p>
			</div>
			<div className="modal-footer d-flex justify-content-center">
				<button
					type="button" className="btn btn-grey"
					data-bs-dismiss="modal">{ Strings.cancel }</button>
				<button
					type="button" className="btn btn_1" onClick={ () => {
					this.props.onAccept();
				} }>{ Strings.accept }</button>
			</div>
		</Popup>;
	}
}

export default GreenListRemovePopUp;
